import { render, staticRenderFns } from "./SkinAndScubaDivingQuestionnaire.vue?vue&type=template&id=f1344cd8"
import script from "./SkinAndScubaDivingQuestionnaire.vue?vue&type=script&lang=js"
export * from "./SkinAndScubaDivingQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports